import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b96a8684")

_pushScopeId("data-v-b96a8684")
const _hoisted_1 = { id: "product-new-line-modal" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row edit-row" }
const _hoisted_4 = { class: "editing-title" }
const _hoisted_5 = { class: "row edit-row" }
const _hoisted_6 = { class: "editing-wrapper" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "product-new-line-box-title" }
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_11 = { class: "product-new-price-data-block" }
const _hoisted_12 = {
  key: 0,
  class: "product-new-price-data-block-item"
}
const _hoisted_13 = { class: "product-new-line-box-title" }
const _hoisted_14 = { class: "invalid-feedback" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_16 = { class: "product-new-price-data-block-item" }
const _hoisted_17 = { class: "product-new-line-box-title" }
const _hoisted_18 = { class: "invalid-feedback" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_20 = {
  key: 1,
  class: "product-new-price-data-block-item"
}
const _hoisted_21 = { class: "product-new-line-box-title" }
const _hoisted_22 = { class: "new-line-footer-total" }
const _hoisted_23 = { class: "product-new-line-box-title pr7" }
const _hoisted_24 = { class: "product-new-line-sum" }
const _hoisted_25 = { class: "new-line-footer-total-currency" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = {
  class: "save-button-wrapper popup-bookit-button w-100",
  type: "submit"
}
const _hoisted_28 = {
  key: 0,
  class: "col-6"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("form", {
      onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => ($setup.submitForm($event)), ["prevent"])),
      novalidate: "",
      class: "popup-container"
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", null, _toDisplayString(_ctx.$t('order.newInvoice.editNewLine.title')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('order.newInvoice.editNewLine.itemDescription')), 1),
              _createVNode("div", null, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.item.name = $event)),
                  required: "",
                  class: "bookit-input w100",
                  type: "text",
                  maxlength: "100"
                }, null, 512), [
                  [_vModelText, $setup.item.name]
                ]),
                _createVNode("span", _hoisted_9, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                (!$props.isCreditInvoice)
                  ? (_openBlock(), _createBlock("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('order.newInvoice.editNewLine.QTY')), 1),
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.item.quantity = $event)),
                        onKeypress: _cache[3] || (_cache[3] = ($event: any) => ($setup.filterKeyQty($event))),
                        onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.checkChangeQty())),
                        class: "bookit-input w100",
                        type: "text",
                        required: ""
                      }, null, 544), [
                        [_vModelText, $setup.item.quantity]
                      ]),
                      _createVNode("span", _hoisted_14, [
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, _toDisplayString($props.isCreditInvoice
                                                ? _ctx.$t('order.newInvoice.editNewLine.amount')
                                                : _ctx.$t('order.newInvoice.editNewLine.unitPrice')), 1),
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.item.pricePerUnit = $event)),
                    onKeypress: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isNumberAllowNegative($event, $props.isPerfomaInvoice))),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.checkChangePrice($props.isPerfomaInvoice))),
                    class: "bookit-input w100",
                    type: "text",
                    required: ""
                  }, null, 544), [
                    [_vModelText, $setup.item.pricePerUnit]
                  ]),
                  _createVNode("span", _hoisted_18, [
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                  ])
                ]),
                (!$props.isCreditInvoice)
                  ? (_openBlock(), _createBlock("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('newOrder.discount')), 1),
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ($setup.item.discount = $event)),
                        onKeypress: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isNumberAllowNegative($event, $props.isPerfomaInvoice))),
                        onFocus: _cache[10] || (_cache[10] = ($event: any) => ($setup.item.discount = $setup.item.discount == 0 ? '' : $setup.item.discount)),
                        onBlur: _cache[11] || (_cache[11] = ($event: any) => ($setup.item.discount = $setup.item.discount == '' ? 0 : $setup.item.discount)),
                        onChange: _cache[12] || (_cache[12] = ($event: any) => ($setup.checkChangeDiscount($props.isPerfomaInvoice))),
                        class: "bookit-input w100",
                        type: "text"
                      }, null, 544), [
                        [_vModelText, $setup.item.discount]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('order.newInvoice.editNewLine.total')), 1),
                _createVNode("span", _hoisted_24, [
                  _createTextVNode(_toDisplayString(_ctx.formatAmount($setup.getTotal)) + " ", 1),
                  _createVNode("span", _hoisted_25, _toDisplayString($setup.getCurrencySymbol($setup.item.currencyId)), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", {
          class: ["row edit-row", [$setup.isNew ? 'popup-two-buttons' : 'popup-three-buttons']]
        }, [
          _createVNode("div", _hoisted_26, [
            _createVNode("button", _hoisted_27, _toDisplayString(_ctx.$t('button.save')), 1)
          ]),
          (!$setup.isNew)
            ? (_openBlock(), _createBlock("div", _hoisted_28, [
                _createVNode("button", {
                  class: "clear-all-button-wrapper delete-button popup-bookit-button w-100",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.deleteRow())),
                  type: "button"
                }, _toDisplayString(_ctx.$t('button.delete')), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: [$setup.isNew ? 'col-12' : 'col-6']
          }, [
            _createVNode("button", {
              class: "close-button-wrapper popup-bookit-button w-100",
              onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.close())),
              type: "button"
            }, _toDisplayString(_ctx.$t('button.close')), 1)
          ], 2)
        ], 2)
      ])
    ], 32)
  ]))
})